import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_GOAL_PORTFOLIO_ITEMS_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_GOAL_PORTFOLIO_ITEMS_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_GOAL_PORTFOLIO_ITEMS_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-programs/${id}/portfolio-items`,
    method: 'GET',
  })
);

export default apiCall;
